﻿import * as React from 'react';
import { Modal } from 'react-bootstrap';

type ConfirmationModalProps = {
    onClose: () => void;
    isOpen: boolean;
    title: string;
    textContent: React.ReactNode;
} & { children: React.ReactNode };

function ConfirmationModal({
    onClose,
    children,
    title,
    textContent,
    isOpen
}: ConfirmationModalProps) {
    return (
        <Modal show={isOpen} onHide={onClose}>
            <Modal.Header closeButton>
                <h3>{title}</h3>
            </Modal.Header>
            <Modal.Body>{textContent}</Modal.Body>
            <Modal.Footer>{children}</Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;
